import React from 'react';
import Input from './index';
import classnames from 'classnames';
import {CountDown} from '@/components';
import StylesType from '@/types/StylesType';
import './style';

export declare const InputSizes: ["small", "default", "large"];

export interface CodeInputProps  {
    phone: string;
    type: number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string | number | string[] | undefined;
    size?: (typeof InputSizes)[number];
    placeholder?: string;
}

const CodeInput: React.FC<CodeInputProps&StylesType> = props => {
  
    const { prefixCls = 'gc-code-input', phone, onChange, value, placeholder} = props;
  
    return (
        <div className={classnames(prefixCls)}>
            <Input value={value} onChange={onChange} placeholder={placeholder}/>
            <CountDown
                type={props.type}
                isNeedValidatePhone={true}
                phone={phone}
                waitTime={60}
            />
        </div>
    )
  
}

export default CodeInput;
